import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Para quién es este sistema?',
  answer: 'Para cualquier trabajador con ingresos variables — construcción, warehouse, delivery, servicios. Si cobras diferente cada semana y el dinero desaparece, este sistema es para ti.'
}, {
  question: '¿Necesito saber inglés?',
  answer: 'No. Todo el contenido está en español. Los scripts incluyen versiones en español e inglés para que puedas usarlos con cualquier acreedor.'
}, {
  question: '¿Qué pasa si tengo muchas deudas?',
  answer: 'Especialmente si tienes muchas deudas. El sistema empieza exactamente desde ahí — clasificando, ordenando y negociando. No necesitas estar al día para empezar.'
}, {
  question: '¿Funciona si soy trabajador 1099?',
  answer: 'Sí. El Capítulo 13 está dedicado completamente a trabajadores 1099 — cómo guardar para taxes, cuándo pagar, qué deducir y recursos gratuitos disponibles.'
}, {
  question: '¿Cuánto tiempo toma ver resultados?',
  answer: 'La mayoría libera dinero en las primeras 48 horas cancelando suscripciones. Las negociaciones exitosas ocurren típicamente en la primera semana.'
}, {
  question: '¿Qué formato tiene y cómo lo recibo?',
  answer: 'PDF digital. Lo descargas inmediatamente después de pagar. Funciona en tu teléfono, tablet o computadora. Acceso instantáneo — sin esperas.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Tienes 30 días de garantía completa. Si aplicas el sistema y no ves resultados, te devolvemos cada centavo sin preguntas y sin formularios.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-[60px] px-5 bg-brand-dark2" data-id="element-59">
      <div className="max-w-[860px] mx-auto" data-id="element-60">
        <h2 className="text-[clamp(22px,4vw,36px)] font-black text-white mb-3 text-center" data-id="element-61">
          Preguntas Frecuentes
        </h2>

        <div className="max-w-[680px] mx-auto flex flex-col gap-3 mt-10" data-id="element-62">
          {faqs.map((faq, index) => <div key={index} className="bg-brand-dark3 border border-brand-border rounded-xl overflow-hidden" data-id="element-63">
              <button onClick={() => toggleFAQ(index)} className="w-full bg-transparent border-none text-white text-[15px] font-bold py-4.5 px-5.5 text-left cursor-pointer flex justify-between items-center gap-3 transition-colors duration-200 hover:bg-white/5" aria-expanded={openIndex === index} data-id="element-64">
                {faq.question}
                <span className={`text-[22px] text-brand-red shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-65">
                  +
                </span>
              </button>
              <div className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px]' : 'max-h-0'}`} data-id="element-66">
                <p className="px-5.5 pb-4.5 text-sm text-brand-gray leading-[1.7] border-t border-brand-border pt-4" data-id="element-67">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}